angular.module('appSettingTutorial', [
  'ngRoute',
  'ngResource',
  'ngFileUpload',
  'core',
  'core.auth',
  'core.env',
  'pascalprecht.translate',
]);



// WEBPACK FOOTER //
// ./src/app/app-setting/tutorial/tutorial.module.js